/**
 * 사용자 위치 기록 서비스 제공 도메인
 */
export enum GEOLOCATION_VIEW_TYPE {
  /** 동네소식에서 사용되는 지리 정보 타입 */
  HOME_TOWN_NEWS = 'HOME_TOWN_NEWS',
  /** 기타 */
  WELLO_CLIENT = 'WELLO_CLIENT',
}
